export const dispatchReducer = ( state = {}, action ) => {
  switch ( action.type ) {
    case 'dispatch-busy':
      return { ...state, [action.action]: true };
    case 'dispatch-complete':
      return { ...state, [action.action]: false };
    default:
      return state;
  }
};